export default __webpack_public_path__ + "static/media/rarible-icon.bc8fa802.svg";